import React from 'react';

import { LayoutPage, LayoutDynamicZone, LayoutBlockHero } from 'src/modules/layout';
import { GlobalFormSalesforce, GlobalIcon, IconImage } from 'src/modules/global';
import { useLocale } from 'src/modules/locale';
import { useIntl } from 'react-intl';
import { RetailerEntity } from 'src/modules/retailer';
import styles from './BrandSpacesDetailsPage.module.scss';
import { BreadcrumbsProps } from 'src/modules/professionals/downloads/products/components/breadcrumbs/Breadcrumbs';

export interface BrandSpaceDetailsPageProps {
  page: RetailerEntity;
  parentBreadcrumbs: BreadcrumbsProps['links'];
}

const BrandSpaceDetailsPage: React.FunctionComponent<BrandSpaceDetailsPageProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject } = useLocale();

  // missing content in testing environemnt
  if (!props?.page) return null;

  const parentBreadcrumbs = props.parentBreadcrumbs;

  const {
    display_name: name,
    description,
    slug,
    street,
    zip,
    city,
    lat,
    lng,
    image,
    dynamic_content,
  } = getLocalizedObject(props.page);

  let breadcrumbs = [];

  if (parentBreadcrumbs.length) {
    const lastParentBreadcrumb = parentBreadcrumbs[parentBreadcrumbs.length - 1];

    breadcrumbs = [
      ...parentBreadcrumbs,
      {
        title: name,
        as: `${lastParentBreadcrumb.as}/${slug}`,
        href: `${lastParentBreadcrumb.as}/[slug]`,
      },
    ];
  }

  return (
    <LayoutPage title={name} description={description} breadcrumbs={breadcrumbs}>
      <div className={styles.container}>
        <LayoutBlockHero
          title={name}
          image={image}
          subline={
            <div>
              <p>
                {street}
                {zip && `, ${zip}`}
                {city && `, ${city}`}
              </p>
              <div className={styles.directions}>
                <a
                  className={styles.directions}
                  href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}
                  target="_blank"
                  rel="noreferrer">
                  {intl.formatMessage({ id: 'page/store/get_directions' })}
                  <GlobalIcon image={IconImage.Link} />
                </a>
              </div>

              <GlobalFormSalesforce
                title={intl.formatMessage({ id: 'form/title' })}
                buttonText={intl.formatMessage({ id: 'page/brand_spaces/details/contact' })}
                fullWidth={false}
                additionalFormFields={{ '00N3X00000MKtaU': name }}
                topJsx={
                  <div>
                    <span className={styles.selectedBrandSpaceLabel}>
                      {intl.formatMessage({
                        id: 'page/brand_spaces/details/inquire/selected_brand_space',
                      })}
                    </span>
                    <h3 className={styles.selectedBrandSpaceName}>{name}</h3>
                    <div className={styles.thinLine} />
                  </div>
                }
              />
            </div>
          }
        />

        {dynamic_content && <LayoutDynamicZone components={dynamic_content} groupCards={true} />}
      </div>
    </LayoutPage>
  );
};

export default BrandSpaceDetailsPage;
